import { useQuery } from '@tanstack/vue-query'
import getOrganisationList from '@/api/organisations/get-organisation-list'

export default function useOrganisationList() {
  return useQuery({
    queryKey: ['organisations:list'],
    queryFn: () => getOrganisationList()
  })
}

